import { Route, BrowserRouter } from "react-router-dom";
import AppLayout from "./common/components/AppLayout";
import { createBrowserHistory } from "history";
import React from "react";
import "./App.css";

function App() {
  
  // let currentdomain=window.location.hostname;
  // let currLink = sessionStorage.getItem("currentlink");
  //   let currentLink = window.location.href;
  //   if(currLink !='')
  //   {
  //     
  //   if (currLink != currentLink  && currentdomain === 'localhost') {
  
  //     sessionStorage.setItem("prevlink", currLink);
  //     sessionStorage.setItem("currentlink", currentLink);

  //     window.location.href = 'http://localhost:3001/admin/test';
  //     }
  //   }
  //   else{
  //     
  //     sessionStorage.setItem("currentlink", currentLink);
  //   }
  const history = createBrowserHistory();

  return (
    <BrowserRouter history={history}>
      <Route exact path="" component={AppLayout} />
    </BrowserRouter>
  );
}

export default App;
